import { Stack, Typography } from '@mui/material';

import { useFenrirTranslation } from '../../../../locales/use-fenrir-translation';

/** @experimental In active development. */
export const GridEmptyOverlay = ({ message }: { message?: string }) => {
  const { t } = useFenrirTranslation({ keyPrefix: 'dataGrid' });
  return (
    <Stack
      sx={{ height: '100%', justifyContent: 'center', alignItems: 'center' }}
    >
      <Typography>{message ?? t('empty')}</Typography>
    </Stack>
  );
};
